import React, { useState, useEffect } from 'react';
import "./AnimationText.css";

const texts = [
    { message: `"Ton corps, ton choix. Personne ne décide à ta place."`, author: "YouthFP" },
    { message: `"Parler, c’est se libérer. Brise le silence sur les violences."`, author: "YouthFP" },
    { message: `"L'information, c’est le pouvoir. Renseigne-toi, protège-toi."`, author: "YouthFP" },
    { message: `"Tu mérites le respect, toujours."`, author: "YouthFP" },
    { message: `"S’aimer, c’est aussi se protéger."`, author: "YouthFP" },
    { message: `"Le consentement, c’est simple : c’est oui ou c’est non."`, author: "YouthFP" },
    { message: `"Tu n'es jamais seul.e. On est ensemble."`, author: "YouthFP" },
    { message: `"Une grossesse non désirée ? Tu as des options. Tu as des droits."`, author: "YouthFP" },
    { message: `"On ne juge pas. On soutient."`, author: "YouthFP" },
    { message: `"Le VIH ne définit pas une personne. Le stigma, si."`, author: "YouthFP" },
    { message: `"La honte n’a pas sa place. Tu as le droit de parler de sexualité."`, author: "YouthFP" },
    { message: `"Prendre soin de sa santé sexuelle, c’est un acte de force."`, author: "YouthFP" },
    { message: `"Sois libre. Sois informé.e. Sois protégé.e."`, author: "YouthFP" },
    { message: `"Se faire dépister, c’est se respecter."`, author: "YouthFP" },
    { message: `"La prévention, c’est la vraie protection."`, author: "YouthFP" },
    { message: `"Le respect, c’est sexy."`, author: "YouthFP" },
    { message: `"L’éducation sexuelle, c’est pour tout le monde."`, author: "YouthFP" },
    { message: `"Le silence sur les VBG tue. Ta voix peut sauver."`, author: "YouthFP" },
    { message: `"La santé sexuelle, ce n’est pas un luxe. C’est un droit."`, author: "YouthFP" },
    { message: `"Un rapport consenti, c’est un rapport voulu par tous."`, author: "YouthFP" },
    { message: `"Avoir accès à l’avortement sécurisé, c’est une question de justice."`, author: "YouthFP" },
    { message: `"Protéger les autres, c’est aussi se protéger."`, author: "YouthFP" },
    { message: `"Le préservatif, c’est du respect en action."`, author: "YouthFP" },
    { message: `"Les MST ne jugent pas. Les gens ne devraient pas non plus."`, author: "YouthFP" },
    { message: `"Les jeunes ont le pouvoir de changer les choses."`, author: "YouthFP" },
    { message: `"Ta douleur est réelle. Ton histoire compte."`, author: "YouthFP" },
    { message: `"Ton bien-être sexuel est aussi important que ta santé physique."`, author: "YouthFP" },
    { message: `"Les tabous d’hier ne doivent pas être les silences d’aujourd’hui."`, author: "YouthFP" },
    { message: `"L’amour ne fait jamais mal. La violence, si."`, author: "YouthFP" },
    { message: `"Une personne informée peut en aider dix."`, author: "YouthFP" },
    { message: `"Éduquer, c’est protéger. Parlons sexualité sans gêne."`, author: "YouthFP" },
    { message: `"Les jeunes ont le droit d’être entendus sur les sujets qui les concernent."`, author: "YouthFP" },
    { message: `"On peut être jeune et conscient.e."`, author: "YouthFP" },
    { message: `"Le changement commence par une conversation."`, author: "YouthFP" },
    { message: `"Aucune honte à demander de l’aide. Jamais."`, author: "YouthFP" },
    { message: `"Les préjugés tuent. L’information sauve."`, author: "YouthFP" },
    { message: `"Les droits sexuels sont des droits humains."`, author: "YouthFP" },
    { message: `"Tu n’as pas à te taire. Tu as le droit de dire non."`, author: "YouthFP" },
    { message: `"Un.e ami.e qui écoute peut tout changer."`, author: "YouthFP" },
    { message: `"On ne devrait jamais avoir peur d’aller chez le médecin."`, author: "YouthFP" },
    { message: `"Ton histoire est importante. Elle peut inspirer."`, author: "YouthFP" },
    { message: `"La santé mentale et sexuelle vont de pair."`, author: "YouthFP" },
    { message: `"Déconstruire les stéréotypes, c’est bâtir l’égalité."`, author: "YouthFP" },
    { message: `"Ta voix a du pouvoir. Utilise-la."`, author: "YouthFP" },
    { message: `"Écouter, c’est déjà agir."`, author: "YouthFP" },
    { message: `"Tu peux être jeune et activiste."`, author: "YouthFP" },
    { message: `"On mérite tous.tes de vivre sans peur."`, author: "YouthFP" },
    { message: `"Soutenir une victime, c’est refuser l’injustice."`, author: "YouthFP" },
    { message: `"Être informé.e, c’est être libre."`, author: "YouthFP" },
    { message: `"Ce n’est pas juste un sujet. C’est notre vie."`, author: "YouthFP" }
  ];
  

const TYPING_SPEED = 50; // ms par lettre
const DISPLAY_TIME = 10000; // 10 secondes
const DELETING_SPEED = 25;
const getRandomIndex = (excludeIndex) => {
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * texts.length);
    } while (newIndex === excludeIndex); // éviter la répétition
    return newIndex;
  };

const AnimatedText = () => {
    const [textIndex, setTextIndex] = useState(() => getRandomIndex(-1));
    const [displayedText, setDisplayedText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
  
    const currentMessage = texts[textIndex].message;
  
    useEffect(() => {
      let timeout;
  
      if (!isDeleting) {
        if (displayedText.length < currentMessage.length) {
          timeout = setTimeout(() => {
            setDisplayedText(currentMessage.slice(0, displayedText.length + 1));
          }, TYPING_SPEED);
        } else {
          timeout = setTimeout(() => setIsDeleting(true), DISPLAY_TIME);
        }
      } else {
        if (displayedText.length > 0) {
          timeout = setTimeout(() => {
            setDisplayedText(currentMessage.slice(0, displayedText.length - 1));
          }, DELETING_SPEED);
        } else {
          setIsDeleting(false);
          setTextIndex((prevIndex) => getRandomIndex(prevIndex)); // Choix aléatoire
        }
      }
  
      return () => clearTimeout(timeout);
    }, [displayedText, isDeleting, textIndex]);
  
    return (
      <div className="max-w-md text-white">
        <blockquote className="text-xl mb-4">
          {displayedText}
          <span className="cursor">|</span>
        </blockquote>
        {displayedText === currentMessage && (
          <cite className="block">
            <span className="font-semibold">Auteur</span> - {texts[textIndex].author}
          </cite>
        )}
      </div>
    );
  };

export default AnimatedText;
